import React, { PureComponent } from 'react';
import { Input } from 'semantic-ui-react';
import style from './styles/style.module.css';

export default class DLTextField extends PureComponent {
    render() {
        const inlineStyle = { ...this.props.style };

        return (
            <div className={ `semantic-wrapper ${ style.semanticTextField } ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            data-name={ this.props.name }
            style={ inlineStyle }>
                { this.props.label &&
                    <label style={ this.props.labelStyle }>{ this.props.label }</label>
                }
                <Input className={ `${ style.semanticInput }` }
                id={ this.props.id }
                value={ this.props.value }
                name={ this.props.name }
                type={ this.props.type }
                autoFocus={ this.props.autoFocus }
                onChange={ this.props.onChange }
                onFocus={ this.props.onFocus }
                onBlur={ this.props.onBlur }
                onKeyDown={ this.props.onKeyDown }
                required={ this.props.required }
                placeholder={ this.props.placeholder }
                error={ !!this.props.error }
                icon={ this.props.icon }
                iconPosition={ this.props.iconPosition }
                maxLength={ this.props.maxLength }
                label={ this.props.internalLabel }
                disabled={ this.props.disabled }
                loading={ this.props.loading }
                fluid />
                { this.props.hintMessage &&
                    <p className='hint-message' style={ this.props.hintStyle }>{ this.props.hintMessage }</p>
                }
                { ( this.props.error || !this.props.noError ) &&
                    <p className='error-message'>{ this.props.error }</p>
                }
            </div>
        );
    }
}

DLTextField.defaultProps = {
    className: '',
    style: {},
};
